var _style, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStressTesting(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#ECF2FA;}\n\t.st1{fill:none;stroke:#1930BA;stroke-width:15;stroke-miterlimit:10;}\n\t.st2{fill:none;stroke:#1930BA;stroke-width:8;stroke-miterlimit:10;}\n\t.st3{fill:none;stroke:#1930BA;stroke-width:8;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M321.4,41.3c0,0,202.7,139.8,169.6,302.9c0,0-34.4,170.3-313.4,137.5c-52.2-6.1-100.1-30.9-131.4-70.3 c-15.2-19.4-26.7-41.4-33.6-65.1C-1,301.4,5,253.2,27.7,211.5C77.3,120.4,193.5-52.7,321.4,41.3"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_4"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 242.8,
    cy: 185.2,
    r: 66.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 163.2,
    cy: 299.2,
    r: 40
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M309.3,168.3h64.8c6.2,0,11.2,5,11.2,11.2v164.6c0,6.2-5,11.2-11.2,11.2H110.8c-6.2,0-11.2-5-11.2-11.2V179.5 c0-6.2,5-11.2,11.2-11.2h64.4"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 147.7,
    y1: 284.3,
    x2: 178.6,
    y2: 313.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 176.4,
    y1: 283.4,
    x2: 148,
    y2: 314.9
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 341.8,
    y1: 289.4,
    x2: 319,
    y2: 310.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 310.7,
    y1: 298.9,
    x2: 318.7,
    y2: 310.1
  })), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 326.2,
    cy: 300.1,
    r: 40
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 205.3,
    y1: 299.1,
    x2: 286.2,
    y2: 299.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 162.5,
    y1: 400.9,
    x2: 329,
    y2: 400.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 126.6,
    y1: 238.9,
    x2: 151.9,
    y2: 238.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 126.6,
    y1: 211.4,
    x2: 151.9,
    y2: 211.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 334.5,
    y1: 238.9,
    x2: 359.8,
    y2: 238.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 334.5,
    y1: 211.4,
    x2: 359.8,
    y2: 211.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 213,
    y1: 362.5,
    x2: 213,
    y2: 399.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 274.1,
    y1: 362.5,
    x2: 274.1,
    y2: 399.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 244.1,
    y1: 282.6,
    x2: 244.1,
    y2: 319.7
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st3",
    points: "197.9,172.1 212.3,198.8 227.1,171.6  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st3",
    points: "226.7,172.1 241,198.8 255.8,171.6  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st3",
    points: "256,172.1 270.4,198.8 285.2,171.6  "
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStressTesting);
export default __webpack_public_path__ + "static/media/stress_testing.5a7667bdcf7d5b6cfa068ae008978f43.svg";
export { ForwardRef as ReactComponent };